import styled from 'styled-components';
import { tc, ts } from 'utils/theme';

export const pBaseStyle = `
  font-style: normal;
  font-size: ${ts('fontSize')};
  line-height: ${ts('lineHeight')};
  letter-spacing: ${ts('letterSpacing')};
  color: ${tc('paragraph')};
  font-weight: normal;
`;

export default styled.p`
  font-style: normal;
  font-size: ${ts('fontSize')};
  line-height: ${ts('lineHeight')};
  letter-spacing: ${ts('letterSpacing')};
  color: ${tc('paragraph')};
  font-weight: normal;
`;
